import { useState, useEffect } from 'react';
import apis from '@/apis';

type SkuTreeVO = {
  id?: number; // 分类id
  key?: number;
  name: string; // 分类名称
  level?: number; // 级别
  isLeaf: number;
  children: SkuTreeVO[];
  pid: string; // 父级id
};

interface CategoryData {
  values?: SkuTreeVO[];
  loading: boolean;
}

export default function useSkuTree() {
  const [categoryData, setCategoryData] = useState({
    values: [],
    loading: true,
  } as CategoryData);

  useEffect(() => {
    // type: 1 类目 2 部门 获取类目表, 只展示二级类目
    apis.statisticTree({ type: 1 }, 3).then((res) => {
      setCategoryData({
        loading: false,
        values: transformKeyToId(res.data),
      });
    });
  }, []);

  // 映射雷缪树key->id
  function transformKeyToId(list: SkuTreeVO[]) {
    if (!list || list.length === 0) return;

    list.forEach((item) => {
      item.id = item.key;
      transformKeyToId(item.children);
    });

    return list;
  }

  return {
    categoriesLoadStatus: categoryData.loading,
    categories: categoryData.values,
  };
}
